import { createContext } from '@chakra-ui/react-utils';
import { type SystemStyleObject } from '@chakra-ui/react-v2';

import type { SearchInputPart } from './types';

export type SearchInputStyles = Partial<
  Record<SearchInputPart, SystemStyleObject>
>;

const [SearchInputStylesProvider, useSearchInputStyles] =
  createContext<SearchInputStyles>({
    name: 'SearchInputStylesContext',
    errorMessage:
      'useSearchInputStyles: `context` is undefined. Seems you used a SearchInput sub-component that required a styles context outside of a SearchInput component.',
  });

export { SearchInputStylesProvider, useSearchInputStyles };
